var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9545 17.4199V20.4199C22.9557 20.6984 22.8986 20.974 22.787 21.2292C22.6755 21.4844 22.5118 21.7134 22.3066 21.9017C22.1014 22.09 21.8591 22.2333 21.5953 22.3226C21.3314 22.4118 21.0519 22.4449 20.7745 22.4199C17.6974 22.0855 14.7415 21.034 12.1445 19.3499C9.72835 17.8145 7.67986 15.766 6.14452 13.3499C4.4545 10.7411 3.40277 7.77085 3.07452 4.67985C3.04953 4.40332 3.0824 4.12461 3.17102 3.86148C3.25965 3.59834 3.40209 3.35654 3.58929 3.15147C3.77648 2.94641 4.00433 2.78256 4.25831 2.67037C4.5123 2.55819 4.78686 2.50011 5.06452 2.49985H8.06452C8.54983 2.49508 9.02031 2.66693 9.38828 2.98339C9.75625 3.29984 9.9966 3.7393 10.0645 4.21985C10.1911 5.17992 10.426 6.12258 10.7645 7.02985C10.8991 7.38778 10.9282 7.77677 10.8484 8.15073C10.7687 8.5247 10.5834 8.86796 10.3145 9.13985L9.04452 10.4099C10.4681 12.9134 12.541 14.9863 15.0445 16.4099L16.3145 15.1399C16.5864 14.871 16.9297 14.6857 17.3036 14.6059C17.6776 14.5262 18.0666 14.5553 18.4245 14.6899C19.3318 15.0284 20.2745 15.2632 21.2345 15.3899C21.7203 15.4584 22.1639 15.7031 22.4811 16.0773C22.7982 16.4516 22.9667 16.9294 22.9545 17.4199Z",
    stroke: "#202020",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/Phone_icon.e17360912d781cf151701a0c16e2767c.svg";
export { ForwardRef as ReactComponent };